<template>
  <el-drawer
    title="用户信息"
    :with-header="false"
    width="50%"
    :visible.sync="visible">
    <el-descriptions title="用户信息" :column="1" border style="margin: 20px;">
      <el-descriptions-item label="用户名">{{dataForm.loginName}}</el-descriptions-item>
      <el-descriptions-item label="姓名">{{dataForm.realName}}</el-descriptions-item>
      <el-descriptions-item label="邮箱">{{dataForm.mail}}</el-descriptions-item>
      <el-descriptions-item label="手机号">
        {{dataForm.mobile}}
      </el-descriptions-item>
      <el-descriptions-item label="租户">{{dataForm.tenantName}}</el-descriptions-item>
      <el-descriptions-item label="默认主体">{{dataForm.defaultMainBodyId}}</el-descriptions-item>
      <el-descriptions-item label="性别">{{dataForm.gender}}</el-descriptions-item>
      <el-descriptions-item label="用户状态">{{dataForm.userStatus}}</el-descriptions-item>
      <el-descriptions-item label="角色">
        <el-tag size="small" type="info">角色1</el-tag>
        <el-tag size="small" type="info">角色2</el-tag>
        <el-tag size="small" type="info">角色3</el-tag>
        <el-tag size="small" type="info">角色1</el-tag>
        <el-tag size="small" type="info">角色2</el-tag>
        <el-tag size="small" type="info">角色3</el-tag>
      </el-descriptions-item>
      <el-descriptions-item label="岗位">
        <el-tag size="small" type="info">岗位1</el-tag>
        <el-tag size="small" type="info">岗位2</el-tag>
        <el-tag size="small" type="info">岗位3</el-tag>
      </el-descriptions-item>
      <el-descriptions-item label="组织">
        <p>智能制造
        </p>
      </el-descriptions-item>
    </el-descriptions>

  </el-drawer>
</template>

<script>
  import {getUserById, fetchMainBodyByUserId} from '@/controller/sys'
  import { isEmail, isMobile } from '@/utils/validate'
  export default {
    data () {
      let validatePassword = (rule, value, callback) => {
        if (!this.dataForm.id && !/\S/.test(value)) {
          callback(new Error('密码不能为空'))
        } else {
          callback()
        }
      }
      let validateComfirmPassword = (rule, value, callback) => {
        if (!this.dataForm.id && !/\S/.test(value)) {
          callback(new Error('确认密码不能为空'))
        } else if (this.dataForm.password !== value) {
          callback(new Error('确认密码与密码输入不一致'))
        } else {
          callback()
        }
      }
      let validateEmail = (rule, value, callback) => {
        if (!isEmail(value)) {
          callback(new Error('邮箱格式错误'))
        } else {
          callback()
        }
      }
      let validateMobile = (rule, value, callback) => {
        if (!isMobile(value)) {
          callback(new Error('手机号格式错误'))
        } else {
          callback()
        }
      }
      return {
        visible: false,
        initValue: {
        },
        // 主要用于存储和页面显示相关的数据以及状态
        view: {
        },
        // 用于存储form 中的数据
        dataForm: {
          id: 0,
          loginName: '',
          password: '',
          comfirmPassword: '',
          realName: '',
          typeId: 3,
          userTypeList: [],
          mail: '',
          mobile: '',
          defaultMainBodyId: '',
          mainBodyList: [],
          gender: '',
          userStatus: 1,
          tenantId: '',
          tenantName: ''
        },
        dataRule: {
          loginName: [
            { required: true, message: '用户名不能为空', trigger: 'blur' }
          ],
          realName: [
            { required: true, message: '用户姓名不能为空', trigger: 'blur' }
          ],
          password: [
            { validator: validatePassword, trigger: 'blur' }
          ],
          comfirmPassword: [
            { validator: validateComfirmPassword, trigger: 'blur' }
          ],
          mail: [
            { required: true, message: '邮箱不能为空', trigger: 'blur' },
            { validator: validateEmail, trigger: 'blur' }
          ],
          mobile: [
            { required: true, message: '手机号不能为空', trigger: 'blur' },
            { validator: validateMobile, trigger: 'blur' }
          ],
          tenantName: [
            { required: true, message: '请先在页面顶部导航栏选择租户', trigger: 'blur' }
          ],
          typeId: [
            { required: true, message: '用户类型不能为空', trigger: 'blur' }
          ]
        }
      }
    },
    methods: {
      init (id) {
        this.visible = true
        this.dataForm.id = id || 0
        this.dataForm.tenantId = this.$store.state.tenant.id
        this.dataForm.tenantName = this.$store.state.tenant.name
        this.$nextTick(() => {
          this.dataForm.userTypeList = []
          if(this.$store.state.user.userInfo.typeId === 1){
            this.dataForm.userTypeList.push({'value': 1, 'label': '超级管理员'})
          }
          this.dataForm.userTypeList.push({'value': 2, 'label': '管理员'})
          this.dataForm.userTypeList.push({'value': 3, 'label': '普通用户'})
          if (this.dataForm.id) {
            fetchMainBodyByUserId({},this.dataForm.id).then(data => {
              if (data && data.code === '00') {
                this.dataForm.mainBodyList = data.body
              }
              getUserById(
                      {id: this.dataForm.id}
              ).then(data => {
                if (data && data.code === '00') {
                  this.dataForm = {...this.dataForm, ...data.body}
                }
              })
            })
          }
        })
      }
    }
  }
</script>
<style lang="scss">
  .el-dialog__body{
    .user-info-dialog-form{
      width: 95%;
      .el-select{
        width: 222px;
      }
    }
  }
</style>